(function () {
  'use strict';
  if (window.__rdtfRvInit) return;
  window.__rdtfRvInit = 1;
  function boot() {
  var qs = new URLSearchParams(location.search);
  var els = document.querySelectorAll('[data-rdtf-rv-gate]');
  if (!els.length) return;
  var anyVisible = false;
  els.forEach(function (el) {
    if (el.getAttribute('data-rdtf-rv-gate') === 'live' || qs.has('reviews')) {
      el.style.display = ''; anyVisible = true;
    }
  });
  if (!anyVisible) return;

  var JSON_URL = window.__rdtfRvUrl;
  var dataP = null;
  function load() {
    if (!dataP) dataP = fetch(JSON_URL).then(function (r) { return r.json(); });
    return dataP;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function starHtml(n, cls) {
    return '<span class="rdtf-rv-stars ' + (cls || '') + '" style="--f:' + (n / 5 * 100) + '%">★★★★★</span>';
  }
  function thumbUrl(u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200'; }
  function bigUrl(u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=1000'; }

  /* ---- lightbox ---- */
  var lb, lbItems = [], lbIdx = 0;
  function ensureLb() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.id = 'rdtf-rv-lb';
    lb.innerHTML = '<button class="lb-x" aria-label="Close">×</button>' +
      '<button class="lb-nav lb-prev" aria-label="Previous">‹</button>' +
      '<div class="lb-media"></div><div class="lb-cap"></div>' +
      '<button class="lb-nav lb-next" aria-label="Next">›</button>';
    document.body.appendChild(lb);
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.className === 'lb-x') close();
      else if (e.target.classList.contains('lb-prev')) show(lbIdx - 1);
      else if (e.target.classList.contains('lb-next')) show(lbIdx + 1);
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(lbIdx - 1);
      if (e.key === 'ArrowRight') show(lbIdx + 1);
    });
    return lb;
  }
  function show(i) {
    lbIdx = (i + lbItems.length) % lbItems.length;
    var it = lbItems[lbIdx];
    var box = lb.querySelector('.lb-media');
    box.innerHTML = it.t === 'v'
      ? '<video controls autoplay playsinline src="' + it.u + '"></video>'
      : '<img src="' + bigUrl(it.u) + '" alt="Customer photo">';
    lb.querySelector('.lb-cap').textContent = it.cap || '';
    var nav = lbItems.length > 1 ? '' : 'none';
    lb.querySelector('.lb-prev').style.display = nav;
    lb.querySelector('.lb-next').style.display = nav;
  }
  function openLb(items, i) { ensureLb(); lbItems = items; lb.classList.add('open'); show(i); }
  function close() { lb.classList.remove('open'); lb.querySelector('.lb-media').innerHTML = ''; }

  function heroUrl(u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=640'; }
  function mediaHtml(rev) {
    if (!rev.m || !rev.m.length) return '';
    var first = rev.m[0];
    var firstSrc = first.t === 'v' ? (first.p || '') : heroUrl(first.u);
    var html = '<button type="button" class="rdtf-rv-photo' + (first.t === 'v' ? ' vid' : '') + '" data-mi="0">' +
      (firstSrc ? '<img loading="lazy" src="' + firstSrc + '" alt="">' : '') + '</button>';
    if (rev.m.length > 1) {
      html += '<div class="rdtf-rv-media">' + rev.m.slice(1).map(function (m, i) {
        var src = m.t === 'v' ? (m.p || '') : thumbUrl(m.u);
        return '<button type="button" class="rdtf-rv-thumb' + (m.t === 'v' ? ' vid' : '') +
          '" data-mi="' + (i + 1) + '">' + (src ? '<img loading="lazy" src="' + src + '" alt="">' : '') + '</button>';
      }).join('') + '</div>';
    }
    return html;
  }
  function cardHtml(rev) {
    var ini = (rev.a || '?').trim().charAt(0).toUpperCase() || '?';
    var hasMedia = rev.m && rev.m.length;
    var body = '<div class="rdtf-rv-card-head"><span class="rdtf-rv-avatar">' + esc(ini) + '</span>' +
      '<span class="rdtf-rv-author">' + esc(rev.a || 'Anonymous') + '</span>' +
      '<span class="rdtf-rv-date">' + esc(rev.d) + '</span></div>' +
      starHtml(rev.s) +
      (rev.v ? ' <span class="rdtf-rv-verified">✓ Verified purchase</span>' : '') +
      (rev.t ? '<p class="rdtf-rv-text">' + esc(rev.t) + '</p>' : '') +
      (rev.r ? '<div class="rdtf-rv-reply"><b>Reply from RollDTF</b>' + esc(rev.r) + '</div>' : '');
    return '<div class="rdtf-rv-card' + (hasMedia ? ' has-media' : '') + '" data-rid="' + rev.id + '">' +
      mediaHtml(rev) + '<div class="rdtf-rv-card-body">' + body + '</div></div>';
  }

  /* ---- tam widget ---- */
  document.querySelectorAll('.rdtf-rv-widget').forEach(function (w) {
    if (w.style.display === 'none') return;
    var group = w.getAttribute('data-group');
    load().then(function (data) {
      var all = data.reviews.filter(function (r) { return group === 'all' || r.g === group; });
      var agg = group === 'all' ? null : data.groups[group];
      var hist = w.querySelector('.rdtf-rv-hist');
      var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      if (agg) counts = agg.hist;
      else all.forEach(function (r) { counts[r.s]++; });
      var total = all.length || 1;
      var starSel = 0;
      hist.innerHTML = [5, 4, 3, 2, 1].map(function (s) {
        var c = counts[s] || 0;
        return '<div class="rdtf-rv-hrow" data-star="' + s + '"><span>' + s + ' ★</span>' +
          '<span class="bar"><i style="width:' + (c / total * 100) + '%"></i></span>' +
          '<span class="n">' + c + '</span></div>';
      }).join('');

      var state = { page: 1, per: 12, photos: false, sort: 'featured' };
      var list = w.querySelector('[data-rv-list]');
      var moreBtn = w.querySelector('[data-rv-more]');
      function filtered() {
        var arr = all.slice();
        if (state.photos) arr = arr.filter(function (r) { return r.m && r.m.length; });
        if (starSel) arr = arr.filter(function (r) { return r.s === starSel; });
        if (state.sort === 'newest') arr.sort(function (a, b) { return a.d < b.d ? 1 : -1; });
        if (state.sort === 'highest') arr.sort(function (a, b) { return b.s - a.s; });
        if (state.sort === 'lowest') arr.sort(function (a, b) { return a.s - b.s; });
        return arr;
      }
      function render() {
        var arr = filtered();
        var shown = arr.slice(0, state.page * state.per);
        list.innerHTML = shown.map(cardHtml).join('') ||
          '<p style="opacity:.6;padding:14px 0">No reviews match this filter.</p>';
        moreBtn.style.display = shown.length < arr.length ? '' : 'none';
        list.querySelectorAll('.rdtf-rv-card').forEach(function (card) {
          var rev = shown.find(function (r) { return String(r.id) === card.getAttribute('data-rid'); });
          card.querySelectorAll('.rdtf-rv-thumb, .rdtf-rv-photo').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var items = rev.m.map(function (m) { return { t: m.t, u: m.u, cap: rev.t }; });
              openLb(items, parseInt(btn.getAttribute('data-mi'), 10));
            });
          });
        });
      }
      moreBtn.addEventListener('click', function () { state.page++; render(); });
      w.querySelector('[data-rv-filter]').addEventListener('click', function () {
        state.photos = !state.photos; state.page = 1;
        this.classList.toggle('active', state.photos); render();
      });
      w.querySelector('[data-rv-sort]').addEventListener('change', function () {
        state.sort = this.value; state.page = 1; render();
      });
      hist.addEventListener('click', function (e) {
        var row = e.target.closest('.rdtf-rv-hrow');
        if (!row) return;
        var s = parseInt(row.getAttribute('data-star'), 10);
        starSel = starSel === s ? 0 : s; state.page = 1;
        hist.querySelectorAll('.rdtf-rv-hrow').forEach(function (r2) {
          r2.classList.toggle('active', parseInt(r2.getAttribute('data-star'), 10) === starSel);
        });
        render();
      });
      render();
    });
  });

  /* ---- ana sayfa carousel ---- */
  document.querySelectorAll('[data-rv-carousel]').forEach(function (track) {
    var wrap = track.closest('.rdtf-rv-carousel');
    if (wrap && wrap.style.display === 'none') return;
    load().then(function (data) {
      var pics = data.reviews.filter(function (r) {
        return r.m && r.m.some(function (m) { return m.t === 'i'; }) && r.s >= 4 && r.t;
      }).slice(0, 16);
      if (!pics.length) return;
      var cards = pics.map(function (rev) {
        var img = rev.m.find(function (m) { return m.t === 'i'; });
        return '<div class="rdtf-rv-car-card" data-rid="' + rev.id + '">' +
          '<img loading="lazy" src="' + thumbUrl(img.u).replace('width=200', 'width=460') + '" alt="">' +
          '<div class="rdtf-rv-car-body">' + starHtml(rev.s) +
          '<div class="rdtf-rv-car-txt">' + esc(rev.t) + '</div>' +
          '<div class="rdtf-rv-car-a">' + esc(rev.a || '') + (rev.v ? ' · ✓ Verified' : '') + '</div>' +
          '</div></div>';
      }).join('');
      track.innerHTML = cards + cards; /* kesintisiz kaydırma için çift kopya */
      track.addEventListener('click', function (e) {
        var card = e.target.closest('.rdtf-rv-car-card');
        if (!card) return;
        var rev = pics.find(function (r) { return String(r.id) === card.getAttribute('data-rid'); });
        openLb(rev.m.map(function (m) { return { t: m.t, u: m.u, cap: rev.t }; }), 0);
      });
    });
  });
}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
